import { useMutation } from '@tanstack/react-query';

import { agent } from 'api/agent';

interface Props { }

const twoFaRequestCodeMutation = () => useMutation({
  mutationKey: ['twoFaRequestCode'],
  mutationFn: (body: Props) => agent.getClient(false).post('/twofa/requestCode', body),
});

export default twoFaRequestCodeMutation;
//